import React from "react";
import logoBpn from "../../assets/logo_bpn.png";
import qrKepuasan from "../../assets/qr_kepuasan.png";

const SURVEY_URL = "https://shorturl.at/N1plG";

const PublicFooter = () => {
    return (
        <footer className="pp-footer mt-auto">
            <div className="pp-footer-accent" aria-hidden="true"></div>
            <div className="pp-container pp-footer-in">
                <div className="pp-footer-brand">
                    <img src={logoBpn} alt="Logo Bahagian Penguatkuasaan JAIS" className="pp-footer-logo" />
                    <div className="pp-footer-address">
                        <div className="pp-footer-dept">BAHAGIAN PENGURUSAN PENGUATKUASAAN</div>
                        <div className="pp-footer-dept">JABATAN AGAMA ISLAM SELANGOR</div>
                        <div>Aras Bawah &amp; Tingkat 4, Menara Utara,</div>
                        <div>Bangunan Sultan Idris Shah, No 2 Persiaran Masjid,</div>
                        <div>40676 Shah Alam, Selangor</div>
                        <div className="pp-footer-hotline">Hotline JAIS (24 Jam): 1 800 88 2424</div>
                    </div>
                </div>

                <div className="pp-footer-qr">
                    <a href={SURVEY_URL} target="_blank" rel="noopener noreferrer" aria-label="Kajian Kepuasan Pelanggan">
                        <img src={qrKepuasan} alt="QR Kajian Kepuasan Pelanggan" className="pp-footer-qr-img" />
                    </a>
                    <span>Kajian Kepuasan Pelanggan</span>
                </div>
            </div>

            <div className="pp-footer-copy">
                &copy; 2026 Sistem Pengurusan Penguatkuasaan Syariah Negeri Selangor (i-SYAEMS). Hak Cipta Terpelihara.
            </div>
        </footer>
    );
};

export default PublicFooter;
